
import { defineComponent } from "vue";
import SubCatalogueGrid from "@/components/controls/catalogueGrid/SubCatalogueGrid.vue";
import { TableDesignConfig } from "@/components/controls/catalogueGrid/tableDesignConfig";
import { TableEditingConfig } from "@/components/controls/catalogueGrid/tableEditingConfig";
import { TableSelectionConfig } from "@/components/controls/catalogueGrid/tableSelectionConfig";
import { TextColumnConfig } from "@/components/controls/catalogueGrid/columns/textColumnConfig";
import { IntegerColumnConfig } from "@/components/controls/catalogueGrid/columns/integerColumnConfig";
import { requiredRule } from "@/components/controls/catalogueGrid/columns/baseValidationRules";
import orderCommentVolumeConstraintCreateEditDialog from "@/components/catalogues/OrderCommentCatalogue/OrderCommentVolumeConstraintCreateEditDialog.vue";

export default defineComponent({
  components: {
    SubCatalogueGrid,
  },
  props: {
    parentModel: { required: true },
  },
  computed: {
    orderCommentVolumeConstraintCreateEditDialog: function () {
      return orderCommentVolumeConstraintCreateEditDialog;
    },
    getChangedConfig() {
      return this.editingConfig;
    },
  },
  data() {
    return {
      columns: [
        new TextColumnConfig({
          dataField: "name",
          caption: "Наименование",
          validationRules: [requiredRule],
        }),
        new TextColumnConfig({
          dataField: "typeDescription",
          caption: "Операция",
          validationRules: [requiredRule],
        }),
        new IntegerColumnConfig({
          dataField: "percent",
          caption: "Процент",
        }),
      ],
      selectionConfig: new TableSelectionConfig({
        mode: "single",
        hoverStateEnabled: false,
      }),
      designConfig: new TableDesignConfig({
        popUpColumnsCount: 1,
        popUpWidth: "850px",
        height: "500px",
        pagingMode: "scroll",
        heightScroll: "500px",
        horizontalScroll: false,
      }),
      editingConfig: new TableEditingConfig({
        allowUpdating: true,
        allowAdding: true,
        allowDeleting: true,
        confirmDelete: true,
        allowDataFill: false,
        allowExport: false,
        allowClearFilter: false,
        allowDeleteMultipleRows: false,
      }),
    };
  },
  created() {
    if (this.selectMode) {
      this.editingConfig = this.selectModeEditingConfig;
    }
  },
});
